<template>
  <div class="step-question-template multiple-choice-step-question">
    <div class="question-text" role="heading" aria-level="3" v-html="question.questionText"></div>
    <div class="question-description" v-html="question.questionDescription" v-if="question.questionDescription"></div>

    <MultiSelectOptions v-model="answer" :options="options" :id="question.id" />
    <div v-if="freeTextRequired">
      <div class="question-text" role="heading" aria-level="4" style="margin-top: 20px">
        {{ question.freeTextQuestion }}
      </div>
      <div class="question-description">
        {{ question.freeTextQuestionDescription }}
      </div>
      <textarea
        class="question-additional-notes rounded-md"
        :class="[!!errorMessage ? 'outline outline-2 outline-alert-banner' : '']"
        v-model="freeTextResponse"
        id="free-text-required"
      />
      <div class="question-error" role="alert" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import poster from "../../mixins/poster";
import validator from "../../mixins/validator";
import responseAdapters from "../../mixins/responseAdapters";
import MultiSelectOptions from "./MultiSelectOptions.vue";
import { MultiSelectQuestion } from "../../types";
import _ from "lodash";

export default Vue.extend({
  mixins: [poster, validator],
  inject: ["submitUrl", "csrfHeader", "csrf"],
  components: {
    MultiSelectOptions,
  },
  props: {
    question: {
      type: Object as PropType<MultiSelectQuestion>,
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      answer: this.question.response,
      updatedQuestion: this.question,
      previousAnswer: null,
      responseAdapter: responseAdapters.multiSelect,
      freeTextResponse: this.question.freeTextResponse,
      options: this.question.options,
    };
  },
  created() {
    this.$emit("answer", this.updatedQuestion, this.responseAdapter(this.updatedQuestion));
    this.$emit("update-next-button-status", this.hasOptionsSelected());
  },
  methods: {
    hasOptionsSelected() {
      return !!(this.updatedQuestion.response && this.updatedQuestion.response.length > 0);
    },
  },
  computed: {
    freeTextRequired() {
      return this.answer && this.answer.filter((option) => this.moreInfoOptions.indexOf(option) !== -1).length > 0;
    },
    errorMessage() {
      if (this.showRequired && this.freeTextRequired && !this.hasFilledFreeText) {
        if (this.isDe) {
          return "Bitte beantworten Sie diese Frage, um fortzufahren.";
        }

        return "You must answer the question to continue";
      }

      return null;
    },
    hasFilledFreeText() {
      return this.freeTextResponse != null && this.freeTextResponse.length > 0;
    },
    moreInfoOptions() {
      return this.question.options.filter((option) => option.moreInfo).map((option) => option.value);
    },
    hasInfoPoints() {
      return this.updatedQuestion.infoPoints && this.updatedQuestion.infoPoints.length;
    },
    isDe(): boolean {
      return process.env.REGION === "de";
    },
  },
  watch: {
    freeTextResponse(newValue) {
      this.updatedQuestion.freeTextResponse = newValue;
      this.post(this.responseAdapter(this.updatedQuestion));
    },
    answer(newValue) {
      if (_.isNull(this.previousAnswer)) {
        this.previousAnswer = newValue;
      }

      this.updatedQuestion.response = newValue;
      this.updatedQuestion.isChangedAnswer = this.updatedQuestion.isChangedAnswer || newValue !== this.previousAnswer;

      this.post(this.responseAdapter(this.updatedQuestion));
      this.$emit("update-next-button-status", this.hasOptionsSelected());
    },
  },
});
</script>
